import React, {useEffect, useMemo, useState} from 'react';
import {
    Badge,
    Card,
    Empty,
    Modal,
    Space,
    Tabs,
    Tag,
} from 'antd';
import {
    FileSearchOutlined,
} from '@ant-design/icons';

import {InvocationLogDataPanel} from "./parts/data/invocation.data";
import {InvocationChangeLogsTab} from "./parts/tabs/change-logs/invocation.tabs.change-logs";
import {InvocationLogsTab} from "./parts/tabs/logs/invocation.tabs.logs";
import {InvocationLogResponse} from "../../../../models/logger/logger.data";
import {loggerService} from "../../../../services/logger/logger.service";
import "./invocation.modal.scss"

interface InvocationLogModalProps {
    invocation: string;
    onClose: () => void;
}

const formatStringList = (values?: string[]): string => {
    if (!values?.length) {
        return '—';
    }

    return values.filter(Boolean).join(', ') || '—';
};


export const InvocationModal: React.FC<InvocationLogModalProps> = ({
                                                                          invocation,
                                                                          onClose,
                                                                      }) => {

    const [response, setResponse] = useState<InvocationLogResponse | null>(null);
    const [loading, setLoading] = useState<boolean>(true);

    useEffect(() => {
        loggerService.getInvocationLog(invocation).then(response => {
            setResponse(response)
            setLoading(false);
        })
    }, [invocation]);

    const tabs = useMemo(
        () => [
            {
                key: 'logs',
                label: (
                    <Space size={6}>
                        Logs
                        <Badge count={response?.logs?.length || 0} size="small" />
                    </Space>
                ),
                children: (
                    <InvocationLogsTab
                        logs={response?.logs || []}
                    />
                ),
            },
            {
                key: 'changeLogs',
                label: (
                    <Space size={6}>
                        Change Logs (Parent)
                        <Badge count={response?.changeLogs?.length || 0} size="small" />
                    </Space>
                ),
                children: (
                    <InvocationChangeLogsTab
                        changeLogs={response?.changeLogs || []}
                    />
                ),
            },
            {
                key: 'childrenChangeLogs',
                label: (
                    <Space size={6}>
                        Change Logs (Children)
                        <Badge count={response?.childrenChangeLogs?.length || 0} size="small" />
                    </Space>
                ),
                children: (
                    <InvocationChangeLogsTab
                        changeLogs={response?.childrenChangeLogs || []}
                    />
                ),
            },
        ],
        [response],
    );

    return (
        <Modal
            open
            onCancel={onClose}
            footer={null}
            width="100vw"
            style={{ top: 0, paddingBottom: 0 }}
            styles={{
                body: {
                    padding: 0,
                    height: 'calc(100vh - 56px)',
                    overflow: 'hidden',
                },
            }}
            wrapClassName="invocation-log-modal"
            title={
                <Space size={10}>
                    <FileSearchOutlined />
                    <span>Invocation logs</span>
                    {response?.data?.invocation?.length ? (
                        <Tag color="blue">{formatStringList(response.data.invocation)}</Tag>
                    ) : null}
                </Space>
            }
            loading={loading}
        >
            <div className="invocation-log-modal__content">
                {response ? (
                    <>
                        <InvocationLogDataPanel data={response.data} />

                        <Card className="invocation-log-modal__tabs-card" bordered={false}>
                            <Tabs
                                items={tabs}
                                size="large"
                                destroyInactiveTabPane={false}
                            />
                        </Card>
                    </>
                ) : (
                    <Empty
                        className="invocation-log-modal__empty"
                        description="No invocation log data"
                    />
                )}
            </div>
        </Modal>
    );
}